import ADWToolbar from "./ADWToolbar";
import { Box, Stack } from "@mui/material";
import ADWGrid from "./ADWGrid";
import ADWQuery from "./ADWQuery";
import { useDispatch, useSelector } from "react-redux";
import { selectAdvancedFields, selectLoading, setDataDictionaryModel, setLoading } from "../../dataWranglerSlice";
import { useRef, useState } from "react";
import { AgGridReact } from "@ag-grid-community/react";
import ADWLoadQuery from "./ADWLoadQuery";
import ADWSaveQuery from "./ADWSaveQuery";
import DownloadStartedModal from './DownloadStartedModal';
import ExceededDownloadLimitModal from './ExceededDownloadLimitModal';
import { SortModelItem } from "@ag-grid-community/core";
import ToolSelector from "../ToolSelector";
import RunQueryModal from "./RunQueryModal";
import { useUserInfoQuery } from "../../../../api/userApiSlice";

const AdvancedDataWrangler = ({ filterValue }: any) => {
    const { data: userData } = useUserInfoQuery({});
    const [dragRef, setDragRef] = useState<HTMLElement | null>(null);
    const [tooManySelected, setTooManySelected] = useState(false)
    const [openLoadQueryModal, setOpenLoadQueryModal] = useState(false);
    const [openSaveQueryModal, setOpenSaveQueryModal] = useState(false);
    const [openRunQueryModal, setOpenRunQueryModal] = useState(false);
    const [searchText, setSearchText] = useState(filterValue ?? "")
    const isGuestUser = userData?.id === -1

    const sortModel = useRef<SortModelItem[]>([])
    const gridRef = useRef<AgGridReact>(null);

    const dispatch = useDispatch();

    const fields = useSelector(selectAdvancedFields);
    const isQueryLoading = useSelector(selectLoading);

    const dismissFinished = () => {
        setTooManySelected(false);
        dispatch(setLoading(false));
    }

    const resetGridFilterSettings = () => {
        gridRef.current?.api.setFilterModel(null)
        gridRef.current?.api.deselectAll()
    }

    const updateSortModel = (newSortModel: any) => {
        sortModel.current = newSortModel;
    }

    const downloadDataDictionary = () => {
        const filterModel = gridRef.current?.api.getFilterModel();
        if (!filterModel) return
        dispatch(setDataDictionaryModel({ filterModel, search: searchText, sortModel: sortModel.current }));
    }

    return (
        <>
            <Box
                sx={{
                    display: 'flex',
                    flexDirection: 'column',
                    gap: 3,
                    height: '100%'
                }}
            >
                <Stack flexDirection={"row"} justifyContent={"space-between"} alignItems={"center"}>
                    {!isGuestUser &&
                        <>
                            <ADWToolbar setOpenLoadQueryModal={setOpenLoadQueryModal}
                                resetGridFilterSettings={resetGridFilterSettings}
                                downloadDataDictionary={downloadDataDictionary}/>
                            <ToolSelector/>
                        </>
                    }
                </Stack>

                <Stack
                    height="100%"
                    flexDirection="row">
                    <ADWGrid
                        ref={gridRef}
                        dragZone={dragRef}
                        setSearchText={setSearchText}
                        updateSortModel={updateSortModel}
                        searchText={searchText}
                    />

                    {!isGuestUser &&
                        <ADWQuery
                            ref={(node) => setDragRef(node)}
                            setTooManySelected={setTooManySelected}
                            setOpenSaveQueryModal={setOpenSaveQueryModal}
                            setOpenRunQueryModal={setOpenRunQueryModal}
                        />
                    }
                </Stack>
            </Box>
            <DownloadStartedModal open={isQueryLoading} onClose={dismissFinished}/>
            <ExceededDownloadLimitModal open={tooManySelected} onClose={dismissFinished}
                instruments={Object.keys(fields)}/>
            <ADWLoadQuery open={openLoadQueryModal} setOpen={setOpenLoadQueryModal}/>
            <ADWSaveQuery open={openSaveQueryModal} close={() => setOpenSaveQueryModal(false)}/>
            <RunQueryModal open={openRunQueryModal} close={() => setOpenRunQueryModal(false)}/>
        </>
    );
}

export default AdvancedDataWrangler;